import useListenDataFromRDB from './useListenDataFromRDB'

export default useListenDataFromRDB
